import axios from "./productInstance";
import mapHatchProfile from '@/components/HatchProfile/loadData/mapHatchProfile'
import { HatchProfileFormData } from '@/types/hatchProfile'

const getHatchProfile = async (page: number = 1, size: number = 100): Promise<HatchProfileFormData[] | null> => {
	try {



		const response = await axios.get(`/hatchprofiles/`, {
			params: { page, size },
		});

		return mapHatchProfile(response.data.contents || []) ;

	} catch (error) {
		console.error("Error fetching hatch profile data:", error);
		return null;
	}



};

export default getHatchProfile;
